"use client";
import React, { useState } from "react";
import { AiOutlineMessage } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkDialogExistRequest } from "../../api/messageRequests";
import {
  BlackOutlineButton,
  Button
} from "../../components/buttons";
import { OrderActionDialog, SendMessageDialog, OrderActionWithFilesDialog, ShipOrderDialog } from "../../components/dialogs";

//import ShipOrderModal from "./ShipOrderModal";

function OrderActionButton({
  actionName,
  actionButtonName,
  orderId,
  userType,
  successActionDone,
  modalTitle,
  modalText,
  successActionText,
  modalButtonText,
}) {
  const [modal, setModal] = useState(false);
  return (
    <div>
      {modal && (
        <OrderActionDialog
          modalOpen={modal}
          actionName={actionName}
          modalTitle={modalTitle}
          modalText={modalText}
          successActionText={successActionText}
          modalButtonText={modalButtonText}
          orderId={orderId}
          onClose={() => setModal(false)}
          userType={userType}
          successActionDone={successActionDone}
        />
      )}
      {actionName === "CANCEL_ORDER" ? (
        <button
          className={`underline hover:text-brandYellow`}
          onClick={() => setModal(true)}
        >
          {actionButtonName}
        </button>
      ) : (
        <Button name={actionButtonName} action={() => setModal(true)} />
      )}
    </div>
  );
}

function ActionWithFileButton({
  actionName,
  actionButtonName,
  modalTitle,
  successActionText,
  orderId,
  userType,
  successActionDone,
  modalButtonText
}) {
  const [modal, setModal] = useState(false);
  return (
    <div>
      {modal && (
        <OrderActionWithFilesDialog
        modalTitle={modalTitle}
        successActionText={successActionText}
          modalOpen={modal}
          orderId={orderId}
          onClose={() => setModal(false)}
          userType={userType}
          actionName={actionName}
          successActionDone={successActionDone}
          modalButtonText={modalButtonText}
        />
      )}
      <Button name={actionButtonName} action={() => setModal(true)} />
    </div>
  );
}

function ContactButton({recipientId, productId, buttonName }) {
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.userLogin);
  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo ? userInfo.data.token : ""}`,
    },
  };

  const [modal, setModal] = useState(false);

  const openMessageModal = async () => {
    try {
      const responseData = await checkDialogExistRequest(
        productId,
        recipientId,
        config
      );

      if (responseData.data.success) {
        if (responseData.data.data.existId) {
          navigate(`/messages/details/${responseData.data.data.existId}`);
        } else {
          setModal(true);
        }
      } else {
        throw responseData.data.message;
      }
    } catch (error) {}
  };

  return (
    <div className="w-full">
      {modal && (
        <div className="absolute top-0 left-0">
          <SendMessageDialog
            modalOpen={modal}
            productId={productId}
            recipientId={recipientId}
            onClose={() => setModal(false)}
          />
        </div>
      )}
      <BlackOutlineButton
        name={buttonName}
        action={openMessageModal}
        icon={<AiOutlineMessage />}
      />
    </div>
  );
}

function ShipOrderButton({
  actionName,
  actionButtonName,
  orderId,
  userType,
  successActionDone,
  modalTitle,
  modalText,
  successActionText,
  modalButtonText,
}) {
  const [modal, setModal] = useState(false);
  return (
    <div>
      {modal && (
        <ShipOrderDialog
          modalOpen={modal}
          modalTitle={modalTitle}
          modalText={modalText}
          successActionText={successActionText}
          modalButtonText={modalButtonText}
          orderId={orderId}
          onClose={() => setModal(false)}
          userType={userType}
          actionName={actionName}
          successActionDone={successActionDone}
        />
      )}
      <Button name={actionButtonName} action={() => setModal(true)} />
    </div>
  );
}

export { ContactButton, OrderActionButton, ActionWithFileButton, ShipOrderButton };

